import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { MatchScore } from "./match_score";
import css from "./match_scores.module.scss";

type MatchScoresProps = {
  normalizedScore?: number | null;
  availabilityScore?: number | null;
  wrap?: boolean;
  light?: boolean;
};

export const MatchScores = ({
  normalizedScore,
  availabilityScore,
  wrap = false,
  light = false
}: MatchScoresProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.matches.card.scores" });

  return (
    <div
      className={classNames(css.matchScores, {
        [css.multiline]: wrap
      })}
    >
      <MatchScore title={t("match")} score={normalizedScore} unit="%" isBold light={light} />
      <MatchScore title={t("availability")} score={availabilityScore} unit="%" light={light} />
    </div>
  );
};
